import type {
  AccountlessNatalieEventApiResponse,
  NatalieEventDetail,
  NatalieEventDetailData,
  NatalieEventPublicDetail,
  NatalieEventPublicDetailData,
} from './natalieEvent.types';

export const mapNataliePublicEventDetailFromApi = (data: NatalieEventPublicDetailData): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: data.community.id,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName,
  communityName: data.community.name ?? '',
  status: data.status,
  communityLogo: data.community.logoImageLink ?? null,
  videoUrl: data.videoUrl ?? null,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
});

export const mapNatalieEventDetailFromApi = (data: NatalieEventDetailData): NatalieEventDetail => ({
  id: data.id,
  communityId: data.community.id,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName,
  communityName: data.community.name ?? '',
  status: data.status,
  communityLogo: data.community.logoImageLink ?? null,
  videoUrl: data.videoUrl ?? null,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
});

export const mapAccountlessEventFromApi = (data: AccountlessNatalieEventApiResponse): NatalieEventPublicDetail => ({
  id: data.id,
  communityId: data.community.id,
  endDate: data.endDate,
  name: data.name,
  topic: data.topic,
  description: data.description ?? null,
  ownerName: data.ownerName ?? '',
  communityName: data.community.name ?? '',
  status: data.status,
  durationInMinutes: data.sessionDurationMinutes ?? 0,
  communityLogo: data.community.logoImageLink ?? null,
  videoUrl: null,
});
